export const spreadsheetProducts = [
  { product: "Nike Dunk Low Vintage", category: "Buty", price: "199 PLN", rating: 5 },
  { product: "Yeezy Slide Bone", category: "Buty", price: "149 PLN", rating: 5 },
  { product: "Essential Hoodie Fear of God", category: "Bluzy", price: "89 PLN", rating: 4 },
  { product: "Carhartt WIP T-Shirt", category: "Koszulki", price: "59 PLN", rating: 4 },
  { product: "North Face Nuptse Jacket", category: "Kurtki", price: "249 PLN", rating: 5 },
  { product: "Gallery Dept Cargo Pants", category: "Spodnie", price: "119 PLN", rating: 4 },
  { product: "New Era 59FIFTY Cap", category: "Nakrycia głowy", price: "49 PLN", rating: 4 },
  { product: "Nike Tech Fleece Set", category: "Zestawy", price: "179 PLN", rating: 5 },
  { product: "Prada Re-Nylon Bag", category: "Torby", price: "299 PLN", rating: 5 },
  { product: "LV Monogram Belt", category: "Paski", price: "159 PLN", rating: 5 },
];